import { put, all, select } from "redux-saga/effects";

import makeRequest from "rdx/utils/makeRequest";
import getErrorActions from "rdx/utils/getErrorActions";
import actions from "rdx/actions";
import messages from "rdx/modules/users/messages";
import selectors from "rdx/modules/users/selectors";

function* updatePermissionsOperation(action) {
  const { success, data, error } = yield* makeRequest.patch(`/operations/${action.payload.id}`, {
    name: action.payload.name,
    description: action.payload.description,
    actions: action.payload.actions,
  });

  if (success && data) {
    const operations = yield select(selectors.getOperations);
    const newOperations = operations.map((o) => {
      if (o.id === action.payload.id) {
        return data.body;
      }
      return o;
    });
    yield all([
      put(actions.setRolesList({ operations: newOperations })),
      put(
        actions.newSuccessEvent({
          message: messages.UPDATE_PERMISSION_OPERATION_SUCCESS,
        }),
      ),
    ]);
  } else if (error) {
    return getErrorActions({
      error,
      message: messages.ERROR_UPDATING_PERMISSION_OPERATION,
    });
  }

  return null;
}

export default updatePermissionsOperation;
